// extracted by mini-css-extract-plugin
export default {"noNumberSpinner":"PaymentDetailPage_noNumberSpinner__0w33s"};